module.exports = __webpack_public_path__ + "img/Karpicko_White_Logo_2020.3a6f7a84.png";